import React from 'react';
import { LinearProgress } from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
import { calcPercent } from '../../../utils/functions';
import './AssessmentProgressBar.scss';

const useStyles = makeStyles({
  linearProgressBar: {
    width: '60%',
    display: 'inline-block',
    height: '13px',
    margin: '5px',
    position: 'relative',
    top: '7px',
    backgroundColor: '#ddd'
  },
  MobileLinearProgressBar: {
    width: '100%',
    display: 'inline-block',
    height: '8px',
    margin: '4px 0px',
    position: 'relative',
    top: '6px',
    backgroundColor: '#ddd'
  }
});

export function AssessmentProgressBar(props) {
  const { answered, total, isMobile } = props;
  const classes = useStyles();

  return (
    <>
      <LinearProgress
        className={isMobile ? classes.MobileLinearProgressBar : classes.linearProgressBar}
        variant="determinate"
        value={calcPercent(answered, total)}
      />
      {!isMobile && <p className="progress-detail">{`${answered}/${total}`}</p>}
    </>
  );
}

export default AssessmentProgressBar;
